export const ADMIN = 'admin';
export const EMPLOYEE = 'employee';




// WEBPACK FOOTER //
// ./src/abilities/roles.js